module.exports = __webpack_public_path__ + "static/media/HIW_steps_1.ba19efd2.jpg";